export default "__VITE_ASSET__DsmV$EBl__"